
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/introduction/priority-support",
      function () {
        return require("private-next-pages/x/introduction/priority-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/introduction/priority-support"])
      });
    }
  